import {ReactElement} from "react";
import {WinePickerSearchField} from "./WinePickerSearchField";
import {FormattedMessage} from "react-intl";
import {connectMenu} from "react-instantsearch-dom";
import {MenuProvided} from "react-instantsearch-core";
import {useAppDispatch, useAppSelector} from "../../lib/redux/hooks";
import {CategoryType, winePickerActions, winePickerSelectors} from "./winePickerSlice";
import {sortBy} from "ramda";
import {algoliaWineCategorySortOrder} from "./winePickerModel";

export interface WinePickerToolbarProps {

}

export function WinePickerToolbar(props: WinePickerToolbarProps): ReactElement {
    const category = useAppSelector(winePickerSelectors.category);
    return (
        <div className="w-full h-[80px] flex
                        bg-warm-gray py-5 pl-11 pr-8">

            <div className="flex-auto self-stretch flex gap-6 items-center">
                <CategorySelect
                    attribute="category"
                    filterItem={item => item.label !== 'Süsswein'}
                    defaultRefinement={category ?? undefined}
                />
            </div>
            <div className="flex-none">
                <WinePickerSearchField/>
            </div>
        </div>
    );
}

interface CategorySelectComponentProps {
    filterItem: (item: (MenuProvided['items'][0])) => boolean
}

function CategorySelectComponent(props: CategorySelectComponentProps & MenuProvided): ReactElement {
    const dispatch = useAppDispatch();
    const allowedItems = sortBy(item => algoliaWineCategorySortOrder(item.label), props.items.filter(props.filterItem));
    const setCategory = (category: CategoryType) => {
        dispatch(winePickerActions.setCategory(category));
        props.refine(category);
    };
    const showFavoriteWines = () => {
        setCategory(null);
        dispatch(winePickerActions.showFavoriteWines());
    };
    const favoriteWinesAvailable = useAppSelector(winePickerSelectors.favoriteWinesAvailable);
    const isFavoriteWinesShowed = useAppSelector(winePickerSelectors.isFavoriteWinesShowed);
    const anyRefined = props.items.find(i => i.isRefined) != null || isFavoriteWinesShowed;

    return (
        <>
            <button className={!anyRefined ? "text-primary font-medium" : ""}
                    onClick={() => setCategory(null)}>
                <FormattedMessage id="winepicker.toolbar.category.all"/>
            </button>
            {favoriteWinesAvailable && <button className={isFavoriteWinesShowed ? "text-primary font-medium" : ""}
                                               onClick={showFavoriteWines}>
                <FormattedMessage id={`winepicker.toolbar.category.Favoriten`}/>
            </button>}
            {allowedItems.map(item => (
                <button key={item.label}
                        className={(item.isRefined&&!isFavoriteWinesShowed) ? "text-primary font-medium" : ""}
                        onClick={() => setCategory(item.value as CategoryType)}>
                    <FormattedMessage id={`winepicker.toolbar.category.${item.label}`}/>
                </button>
            ))}
        </>
    );
}

const CategorySelect = connectMenu(CategorySelectComponent);